<app-header></app-header>

<div class="page-title-area page-title-style-three item-bg4">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li>Specialitati Medicale</li>
            </ul>
            <h2>Specialitati Medicale</h2>
        </div>
    </div>
</div>

<div class="courses-categories-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-4" *ngFor="let specialty of specialites">
                <div class="single-courses-category mb-30" >
                    <a routerLink="/specialitati-medicale/{{specialty.friendlyUrl}}">
                        <i class='{{specialty.photoIcon}}'></i>
                        {{specialty.name}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-bottom-hooks></app-bottom-hooks>
